import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { ParametrosGeneralesUACRouting } from './parametros-generales-UAC-routing.module';
import { ParametrosGeneralesUACComponent } from './parametros-generales-UAC.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ConfiguracionVentanillaComponent } from './configuracion-ventanilla/configuracion-ventanilla.component';
import { ConfigurarMotivoConsultaComponent } from './configurar-motivo-consulta/configurar-motivo-consulta.component';

@NgModule({
    declarations: [
        ParametrosGeneralesUACComponent,
        ConfiguracionVentanillaComponent,
        ConfigurarMotivoConsultaComponent],
    imports: [
        NgxSpinnerModule,
        ParametrosGeneralesUACRouting,
        SharedModule,
        CommonModule
    ],
    entryComponents: [
    
    ]
})

export class ParametrosGeneralesUACModule { }